import { Section } from './section';

/**
 * Représente un groupe de sections dans un dossier.
 */
export class SectionsGroup {
    /**
     * Taille du groupe (en pourcentage).
     */
    public size: number;

    /**
     * Liste des sections du groupe.
     */
    public sections: Section[] = [];

    /**
     * Indique si le groupe est visible.
     */
    public visible: boolean;
}
